import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class JobReady extends BaseDataModel {
	name!: string;
	jobIds!: string[];
	submissionNotes!: string;
	priority!: string;
	submitter!: string;
}
